import React from "react";
import cls from "./recipeCard.module.scss";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import getImage from "utils/getImage";
import FallbackImage from "components/fallbackImage/fallbackImage";
import { IRecipe } from "interfaces/recipe.interface";
import TimeFillIcon from "remixicon-react/TimeFillIcon";
import RestaurantFillIcon from "remixicon-react/RestaurantFillIcon";
import { useAppSelector } from "hooks/useRedux";
import { selectCurrency } from "redux/slices/currency";
import HorizontalLine from "../line/horizontalLine";

type Props = {
  data: IRecipe;
};

export default function RecipeCard({ data }: Props) {
  const { t } = useTranslation();
  const currency = useAppSelector(selectCurrency);

  return (
    <Link
      href={`/recipes/${data?.id}?currency_id=${currency?.id}`}
      className={cls.wrapper}
    >
      <div className={cls.header}>
        <FallbackImage
          fill
          src={getImage(data?.img)}
          alt={data?.translation?.title}
          sizes="400px"
          priority={false}
        />
      </div>
      <div className={cls.body}>
        <div className={cls.main}>
          <h3 className={cls.title}>{data?.translation?.title || t("N/A")}</h3>
          <HorizontalLine color="var(--border-color)" />
          <p className={cls.text}>
            {data?.translation?.description || t("N/A")}
          </p>
        </div>
        <HorizontalLine color="var(--border-color)" />
        <div className={cls.footer}>
          <div className={cls.item}>
            <TimeFillIcon size={20} />
            <span className={cls.text}>
              {data?.total_time} {t("min")}
            </span>
          </div>
          <span className={cls.dot} />
          <div className={cls.item}>
            <RestaurantFillIcon size={20} />
            <span className={cls.text}>
              {data?.calories} {t("kkl")}
            </span>
          </div>
        </div>
        <div className={cls.shopIcon}>
          <FallbackImage
            src={data?.shop?.logo_img}
            alt={data?.shop?.translation?.title}
            fill
            sizes="100px"
          />
        </div>
      </div>
    </Link>
  );
}
